import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import logo from "images/lra_pink.svg";
import { ReactComponent as LogoutIcon } from "feather-icons/dist/icons/log-out.svg";
import { ReactComponent as HomeIcon } from "feather-icons/dist/icons/home.svg";
import { ReactComponent as BookmarkIcon } from "feather-icons/dist/icons/bookmark.svg";
import { ReactComponent as InfoIcon } from "feather-icons/dist/icons/info.svg";
import { ReactComponent as InboxIcon } from "feather-icons/dist/icons/inbox.svg";
import { useAuth, SignOut } from "hooks/auth.js";
import { api } from "supabase/database/api.ts";
import { useNavigate, Outlet, useLocation } from 'react-router-dom';

const Container = tw(
  ContainerBase
)`min-h-screen bg-primary-900 text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-2 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold text-center`;
const FormContainer = tw.div`w-full flex-1 mt-4`;

const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;
const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const Label = tw.label`text-sm text-gray-900 text-center`;
const ValueLabel = tw.label`text-lg text-black font-bold text-center`;

export default ({ logoLinkUrl = "#" }) => {
  const { user } = useAuth();
  const [userData, setUserdata] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const isProfileHome = location.pathname === '/profile';

  useEffect(() => {
    const pullData = async () => {
      const userdata = await api.authQueries.getUserInfo({ email: user.email })
      setUserdata(userdata && userdata[0]);
    };
    pullData();
  }, [user.email]);


  return (
    <>
    <Outlet />
    {isProfileHome && (
      <AnimationRevealPage>
        <Container>
          <Content>
            <MainContainer>
              <LogoLink href={logoLinkUrl}>
                <LogoImage src={logo} />
              </LogoLink>
              <MainContent>
                <Heading>
                  <HighlightedText>{"Member Profile"}</HighlightedText>
                </Heading>
                <FormContainer tw="text-center">
                  <Label>Registration Number:</Label>
                  <br />
                  <ValueLabel>{userData.registration_number}</ValueLabel>
                  <br />
                  <Label>Name:</Label>
                  <br />
                  <ValueLabel>{userData.name}</ValueLabel>
                  <br />
                  <Label>Korean Name:</Label>
                  <br />
                  <ValueLabel>{userData.name_korean}</ValueLabel>
                  <br />
                  <Label>Email:</Label>
                  <br />
                  <ValueLabel>{userData.email}</ValueLabel>
                  <br />
                  <Label>Region:</Label>
                  <br />
                  <ValueLabel>{userData.region}</ValueLabel>
                  <br />
                  <Label>Group:</Label>
                  <br />
                  <ValueLabel>{userData.group}</ValueLabel>
                  <br />
                  <Label>Registration:</Label>
                  <br />
                  <ValueLabel>{userData.registration}</ValueLabel>
                  <br />
                  <SubmitButton onClick={() => navigate("/home")}>
                    <HomeIcon className="icon" />
                    <span className="text">{"Home"}</span>
                  </SubmitButton>
                  <SubmitButton onClick={() => navigate("/bookmarks")}>
                    <BookmarkIcon className="icon" />
                    <span className="text">{"Bookmarks"}</span>
                  </SubmitButton>
                  <SubmitButton onClick={() => navigate("my-information")}>
                    <InfoIcon className="icon" />
                    <span className="text">{"My Information"}</span>
                  </SubmitButton>
                  <SubmitButton onClick={() => navigate("/heavenly-inbox")}>
                    <InboxIcon className="icon" />
                    <span className="text">{"Heavenly Inbox"}</span>
                  </SubmitButton>
                  <SubmitButton onClick={SignOut}>
                    <LogoutIcon className="icon" />
                    <span className="text">{"Sign Out"}</span>
                  </SubmitButton>
                  <p tw="mt-8 text-sm text-gray-600 text-center">
                    Please contact structure if there is any information that
                    needs to be updated.
                  </p>
                </FormContainer>
              </MainContent>
            </MainContainer>
          </Content>
        </Container>
      </AnimationRevealPage>
    )}
    </>
  );
};
